import { useEffect, useState } from "react";
import { usePortfolioBuilderStore } from "@/stores/portfolioBuilderStore";
import { WizardProgress } from "@/components/portfolio-builder/WizardProgress";
import { ExperienceStep } from "@/components/portfolio-builder/ExperienceStep";
import { FinancialStep } from "@/components/portfolio-builder/FinancialStep";
import { GoalsStep } from "@/components/portfolio-builder/GoalsStep";
import { RecommendationStep } from "@/components/portfolio-builder/RecommendationStep";

const STEP_LABELS = ["Experience", "Financial", "Goals", "Results"];

export default function PortfolioBuild() {
  const [mounted, setMounted] = useState(false);
  const { step } = usePortfolioBuilderStore();

  useEffect(() => {
    const frame = requestAnimationFrame(() => setMounted(true));
    return () => cancelAnimationFrame(frame);
  }, []);

  if (!mounted) {
    return (
      <div className="min-h-screen bg-gray-950 flex items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-blue-500 border-t-transparent" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-950 text-white">
      <div className="mx-auto max-w-3xl px-4 py-8">
        <h1 className="mb-2 text-2xl font-bold">Build Your Portfolio</h1>
        <p className="mb-8 text-sm text-gray-400">
          Answer a few questions and we&apos;ll recommend an optimal strategy portfolio
          tailored to your profile.
        </p>

        <WizardProgress currentStep={step} labels={STEP_LABELS} />

        <div className="mt-8">
          {step === 1 && <ExperienceStep />}
          {step === 2 && <FinancialStep />}
          {step === 3 && <GoalsStep />}
          {step === 4 && <RecommendationStep />}
        </div>
      </div>
    </div>
  );
}
